import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import {Button, Card, Col, Form, Modal, Row} from "react-bootstrap";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import {baseUrl, ipAddress, userName} from "../Univ";
const AIPrompt = () => {
    const [prompts, setPrompts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [promptId, setPromptId] = useState(null);
    const initialState = {
        prompt_name: "",
        prompt_code: "",
        prompt_type: "SYSTEM",
        description: "",
        prompt_text: "",
        variables: [],
        version: "1.0",
        is_active: true,
        addedby: userName,
        ip_address: ipAddress
    };
    const [formData, setFormData] = useState(initialState);
    const loadPrompts = async () => {
        try {
            setLoading(true);
            const res = await axios.get(baseUrl + "ai-prompt/");
            setPrompts(res.data);
        } catch {
            Swal.fire("Error", "Unable to load prompts", "error");
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        loadPrompts();
    }, []);
    const handleChange = (e) => {
        const {
            name, value, type, checked
        } = e.target;
        setFormData({
            ...formData, [name]: type === "checkbox" ? checked : value
        });
    };
    const handleVariables = (e) => {
        const value = e.target.value;
        setFormData({
            ...formData, variables: value
                .split(",")
                .map(v => v.trim())
                .filter(v => v)
        });
    };
    // ======================================
// SAVE
// ======================================
    const savePrompt = async () => {
        try {
            if (editMode) {
                await axios.put(baseUrl + `ai-prompt/${promptId}/`, formData);
            } else {
                await axios.post(baseUrl + "ai-prompt/", formData);
            }
            Swal.fire("Success", "AI Prompt Saved Successfully", "success");
            setShow(false);
            resetForm();
            loadPrompts();
        } catch (error) {
            console.log(error);
            Swal.fire("Error", "Unable to Save AI Prompt", "error");
        }
    };
// ======================================
// EDIT
// ======================================
    const editPrompt = (row) => {
        setEditMode(true);
        setPromptId(row.id);
        setFormData({
            prompt_name: row.prompt_name,
            prompt_code: row.prompt_code,
            prompt_type: row.prompt_type,
            description: row.description || "",
            prompt_text: row.prompt_text || "",
            variables: row.variables || [],
            version: row.version,
            is_active: row.is_active,
            addedby: userName,
            ip_address: ipAddress
        });
        setShow(true);
    };
// ======================================
// DELETE
// ======================================
    const deletePrompt = (id) => {
        Swal.fire({
            title: "Delete AI Prompt?",
            text: "This action cannot be undone.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Delete"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await axios.delete(baseUrl + `ai-prompt/${id}/`);
                    Swal.fire("Deleted", "AI Prompt Deleted", "success");
                    loadPrompts();
                } catch {
                    Swal.fire("Error", "Delete Failed", "error");
                }
            }
        });
    };
// ======================================
// RESET
// ======================================
    const resetForm = () => {
        setFormData(initialState);
        setEditMode(false);
        setPromptId(null);
    };
// ======================================
// DATAGRID
// ======================================
    const columns = [{
        field: "id", headerName: "ID", width: 80
    }, {
        field: "prompt_name", headerName: "Prompt Name", flex: 1.4
    }, {
        field: "prompt_code", headerName: "Code", width: 150
    }, {
        field: "prompt_type", headerName: "Type", width: 170
    }, {
        field: "version", headerName: "Version", width: 110
    }, {
        field: "is_active",
        headerName: "Status",
        width: 120,
        renderCell: (params) => params.value ? "Active" : "Inactive"
    }, {
        field: "action", headerName: "Action", width: 180, renderCell: (params) => (<>

            <Button

                size="sm"

                variant="warning"

                className="me-2"

                onClick={() => editPrompt(params.row)}

            >

                Edit

            </Button>

            <Button

                size="sm"

                variant="danger"

                onClick={() => deletePrompt(params.row.id)}

            >

                Delete

            </Button>

        </>)
    }];
    return (<>

        <Card className="shadow mb-3">

            <Card.Header>

                <Row>

                    <Col>

                        <h5>

                            AI Prompt Master

                        </h5>

                    </Col>

                    <Col className="text-end">

                        <Button

                            variant="primary"

                            onClick={() => {
                                resetForm();
                                setShow(true);
                            }}

                        >

                            + Add AI Prompt

                        </Button>

                    </Col>

                </Row>

            </Card.Header>

            <Card.Body>

                <div

                    style={{
                        height: 550, width: "100%"
                    }}

                >

                    <ERPDataGrid

                        rows={prompts}

                        columns={columns}

                        loading={loading}

                    />

                </div>

            </Card.Body>

        </Card>

        <Modal

            show={show}

            onHide={() => setShow(false)}

            size="xl"

        >

            <Modal.Header closeButton>

                <Modal.Title>

                    {editMode ? "Edit AI Prompt" : "Add AI Prompt"}

                </Modal.Title>

            </Modal.Header>

            <Modal.Body>

                <Form>

                    <Row>

                        <Col md={6}>

                            <Form.Group>

                                <Form.Label>

                                    Prompt Name

                                </Form.Label>

                                <Form.Control

                                    name="prompt_name"

                                    value={formData.prompt_name}

                                    onChange={handleChange}

                                />

                            </Form.Group>

                        </Col>

                        <Col md={6}>

                            <Form.Group>

                                <Form.Label>

                                    Prompt Code

                                </Form.Label>

                                <Form.Control

                                    name="prompt_code"

                                    value={formData.prompt_code}

                                    onChange={handleChange}

                                />

                            </Form.Group>

                        </Col>

                    </Row>

                    <Row className="mt-3">

                        <Col md={6}>

                            <Form.Group>

                                <Form.Label>

                                    Prompt Type

                                </Form.Label>

                                <Form.Select

                                    name="prompt_type"

                                    value={formData.prompt_type}

                                    onChange={handleChange}

                                >

                                    <option value="SYSTEM">

                                        System

                                    </option>

                                    <option value="CHAT">

                                        Chat

                                    </option>

                                    <option value="SUMMARY">

                                        Summary

                                    </option>

                                    <option value="REPORT">

                                        Report

                                    </option>

                                    <option value="ANALYTICS">

                                        Analytics

                                    </option>

                                    <option value="PREDICTION">

                                        Prediction

                                    </option>

                                    <option value="RECOMMENDATION">

                                        Recommendation

                                    </option>

                                </Form.Select>

                            </Form.Group>

                        </Col>

                        <Col md={6}>

                            <Form.Group>

                                <Form.Label>

                                    Version

                                </Form.Label>

                                <Form.Control

                                    name="version"

                                    value={formData.version}

                                    onChange={handleChange}

                                />

                            </Form.Group>

                        </Col>

                    </Row>

                    <Row className="mt-3">

                        <Col md={12}>

                            <Form.Group>

                                <Form.Label>

                                    Description

                                </Form.Label>

                                <Form.Control

                                    as="textarea"

                                    rows={3}

                                    name="description"

                                    value={formData.description}

                                    onChange={handleChange}

                                />

                            </Form.Group>

                        </Col>

                    </Row>

                    <Row className="mt-3">

                        <Col md={12}>

                            <Form.Group>

                                <Form.Label>

                                    Prompt Text

                                </Form.Label>

                                <Form.Control

                                    as="textarea"

                                    rows={10}

                                    name="prompt_text"

                                    value={formData.prompt_text}

                                    onChange={handleChange}

                                />

                            </Form.Group>

                        </Col>

                    </Row>
                    <Row className="mt-3">

                        <Col md={12}>

                            <Form.Group>

                                <Form.Label>

                                    Variables (comma separated)

                                </Form.Label>

                                <Form.Control

                                    placeholder="inventory,warehouse,weather,question"

                                    value={formData.variables.join(",")}

                                    onChange={handleVariables}

                                />

                                <Form.Text className="text-muted">

                                    Example:
                                    inventory, warehouse, procurement, worker, weather, question

                                </Form.Text>

                            </Form.Group>

                        </Col>

                    </Row>

                    <Row className="mt-3">

                        <Col md={12}>

                            <div
                                className="border rounded p-3 bg-light"
                            >

                                <strong>

                                    Available ERP Variables

                                </strong>

                                <div className="mt-2">

                <span className="badge bg-primary me-2 mb-2">
                    inventory
                </span>

                                    <span className="badge bg-success me-2 mb-2">
                    warehouse
                </span>

                                    <span className="badge bg-warning text-dark me-2 mb-2">
                    procurement
                </span>

                                    <span className="badge bg-info text-dark me-2 mb-2">
                    worker
                </span>

                                    <span className="badge bg-secondary me-2 mb-2">
                    land
                </span>

                                    <span className="badge bg-danger me-2 mb-2">
                    machine
                </span>

                                    <span className="badge bg-dark me-2 mb-2">
                    finance
                </span>

                                    <span className="badge bg-primary me-2 mb-2">
                    document
                </span>

                                    <span className="badge bg-success me-2 mb-2">
                    iot
                </span>

                                    <span className="badge bg-warning text-dark me-2 mb-2">
                    weather
                </span>

                                    <span className="badge bg-info text-dark me-2 mb-2">
                    dashboard
                </span>

                                    <span className="badge bg-danger me-2 mb-2">
                    question
                </span>

                                </div>

                            </div>

                        </Col>

                    </Row>

                    <Row className="mt-3">

                        <Col md={6}>

                            <Form.Check

                                type="checkbox"

                                label="Active"

                                name="is_active"

                                checked={formData.is_active}

                                onChange={handleChange}

                            />

                        </Col>

                    </Row>

                </Form>

            </Modal.Body>

            <Modal.Footer>

                <Button

                    variant="secondary"

                    onClick={() => setShow(false)}

                >

                    Close

                </Button>

                <Button

                    variant="success"

                    onClick={savePrompt}

                >

                    {editMode ? "Update" : "Save"}

                </Button>

            </Modal.Footer>

        </Modal>

    </>);
};
export default AIPrompt;